export default [
  {
    path: '/admin/corporate-resources',
    name: 'indexCorporateResourcesAdmin',
    meta: { title: 'indexCorporateResourcesAdmin' },
    component: () => import('@/pages/admin/corporate-resources'),
  },
  {
    path: "/admin/corporate-resources/create",
    name: "createCorporateResourcesAdmin",
    meta: { title: 'createCorporateResourcesAdmin' },
    component: () => import('@/pages/admin/corporate-resources/create'),
  },
  {
    path: "/admin/corporate-resources/:id/edit",
    name: "editCorporateResourcesAdmin",
    meta: { title: 'editCorporateResourcesAdmin' },
    component: () => import('@/pages/admin/corporate-resources/edit'),
  },
]
